const commonList = [
  {
    description: 'Unlimited Skills & Resume Credits',
  },
  {
    description: 'Unlimited Self Tape Submissions',
  },
  {
    description: 'Multiple Representation Profiles',
  },
  {
    description: 'Searchable by Casting Directors',
  },
  {
    description: 'Public Shareable Profile Link',
  },
];

export const planContentList = [
  {
    header: 'Free',
    secondHeader: '**A la Carte Media',
    cost: '0',
    list: [
      {
        description: '1 x Primary Image (one change per annum)',
        isBold: true,
      },
      {
        description: '1 x Video (1 minute)',
        isBold: true,
      },
      ...commonList,
    ],
    additionalSection: {
      title: '**Additional Media',
      span: '(one-time-free)',
      footer: '$25 per video, audio or image',
      subFooter: 'Can be used in Profile/s, Media & resume clips',
    },
  },
  {
    header: 'Unlimited',
    secondHeader: '*Unlimited Media',
    cost: '10',
    list: [
      {
        description: 'Unlimited Images',
        isBold: true,
      },
      {
        description: 'Unlimited Video & Audio Files',
        isBold: true,
      },
      ...commonList,
    ],
    additionalSection: {
      title: '*Unlimited Media',
      footer: 'No Cost to add media',
    },
  },
  {
    header: 'Casting Noticeboard Subscription',
    cost: '10',
    list: [
      {
        description: 'Subscription to Casting Noticeboard',
      },
      {
        description: 'Unlimited Submission to Noticeboard Projects',
      },
    ],
    hasFreeButton: true,
  },
];
